import script from "./QuizView.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuizView.vue?vue&type=script&setup=true&lang=ts"

import "./QuizView.vue?vue&type=style&index=0&id=3f55532d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f55532d"]])

export default __exports__